import AboutPage from "@/common/components/about/AboutPage";
import { PAGE_TITLE } from "@/common/constants/constants";
import Head from "next/head";

const About = () => {
  return (
    <>
      <Head>
        <title>{PAGE_TITLE.ABOUT_US}</title>
        <meta name="description" content="JozyJobs app" />
      </Head>
      <AboutPage />
    </>
  );
};
export default About;
